/**
 * @generated SignedSource<<8a510f5eab5c2cd95aa0e3bd4b61b71c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type KeyResultDeleteMutation$variables = {
  keyResultId: string;
};
export type KeyResultDeleteMutation$data = {
  readonly KeyResult_Delete: {
    readonly ok: boolean | null;
  } | null;
};
export type KeyResultDeleteMutation = {
  response: KeyResultDeleteMutation$data;
  variables: KeyResultDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "keyResultId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "keyResultId",
        "variableName": "keyResultId"
      }
    ],
    "concreteType": "DeleteKeyResult",
    "kind": "LinkedField",
    "name": "KeyResult_Delete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KeyResultDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KeyResultDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bc059b975115e1350702fed30bbae696",
    "id": null,
    "metadata": {},
    "name": "KeyResultDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation KeyResultDeleteMutation(\n  $keyResultId: ID!\n) {\n  KeyResult_Delete(keyResultId: $keyResultId) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "bdb55539188bcd69ff1561205b9f4216";

export default node;
